import { SERVICES } from "@/data/services";
import { BAIRROS } from "@/data/bairros";

export const serviceUrl = (s) => `/${s.slug}-em-guarulhos`;
export const bairroUrl = (b) => `/desentupidora-${b.prep}-${b.slug}`;
export const comboUrl = (s, b) => `/${s.slug}-${b.prep}-${b.slug}`;

export const resolveSlug = (slug) => {
  for (const s of SERVICES) {
    if (`${s.slug}-em-guarulhos` === slug) return { type: "service", service: s };
  }
  for (const b of BAIRROS) {
    if (`desentupidora-${b.prep}-${b.slug}` === slug) return { type: "bairro", bairro: b };
    for (const s of SERVICES) {
      if (`${s.slug}-${b.prep}-${b.slug}` === slug) return { type: "combo", service: s, bairro: b };
    }
  }
  return null;
};
